import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { DepositaryReceiptsContactDataModel } from './depositary-receipts-contact.model';

export class DepositaryReceiptsContactConfiguration extends ReportSectionConfigurationBase {
  typeName = 'DepositaryReceiptsContactConfiguration';
  nodataLocalizationKeyName = 'bnyDepositaryReceiptsContact';
  readonly reportSection = ReportSection.DepositaryReceiptsContact;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_DepositaryReceiptsContact];
  minSize = 1;
  maxSize = 4;
  defaultSize = 4;
  order = 14;
  readonly availableDataSections: ReportSectionDataSection[] = [
    {
      name: 'contact1',
      displayName: 'Contact 1',
      isSelected: true,
      canConfigure: true,
      unit: 1
    },
    {
      name: 'contact2',
      displayName: 'Contact 2',
      isSelected: true,
      canConfigure: true,
      unit: 2
    },
    {
      name: 'websiteSubNavTitle',
      displayName: 'Website',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'website'
    }
  ];

  get name(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'depositaryReceiptsContact';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.BnyManagementReport) {
      return 'BNY Depositary Receipts Contact';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface DepositaryReceiptsContactData {
  [ReportViewModelSection.BnyManagementReport_DepositaryReceiptsContact]: {
    depositaryReceiptsContact: DepositaryReceiptsContactDataModel;
    DepositaryReceiptsContact: DepositaryReceiptsContactDataModel;
  };
}
